// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

import { LoadingType } from '../../types/Common';
import { ChallengeCardType } from '../../types/Model';

export interface ChallengeRelatedRequestPayload {
  id: string;
  loadingType: LoadingType;
}
export interface ChallengeRelatedSuccessPayload {
  ChallengeRelatedData: ChallengeCardType[];
  id: string;
  loadingType: LoadingType;
}

export interface ChallengeRelatedFailPayload {
  error: Error;
}

export const getChallengeRelatedActions = createAsyncAction(
  'elearning/GET_CHALLENGE_RELATED',
  'elearning/GET_CHALLENGE_RELATED_SUCCESS',
  'elearning/GET_CHALLENGE_RELATED_FAIL'
)<
  ChallengeRelatedRequestPayload,
  ChallengeRelatedSuccessPayload,
  ChallengeRelatedFailPayload
>();
